import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    if (new URLSearchParams(window.location.search).has('submission_id')) {
      this.checkUploadStatusAndReload()
    }
  }

  async checkUploadStatusAndReload() {
    const urlParams = new URLSearchParams(window.location.search)
    const submissionId = urlParams.get('submission_id')

    if (!submissionId) return

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        if (data.state !== 'in_progress') {
          window.Turbo.visit(window.location.href, { action: 'replace' })
        }
      }
    } catch (error) {
      console.error('Error checking upload status:', error)
    }
  }
}